import { Card } from '@mui/material';
import { PropsWithChildren } from 'react';
import { ActionsButton } from '../actions-button/actions-button.component';
import { LoadedActionsButtonItem } from '../actions-button/actions-button.types';
import { DeliveryCardPlaceholder } from '../placeholders/delivery-card.placeholder';
import { TextPlaceholder } from '../placeholders/text.placeholder';
import { TextButtonColor } from '../text-button/text-button.component';
import { useDeliveryContainerHoverCardStyles } from './hover-card-with-call-to-action.styles';

export type HoverCardWithCallToActionButtonProps = {
  cardTitle: string;
  contentsTitle?: string;
  noContentsMessage?: string;
  isLoading: boolean;
  errorMessage?: string;
  callToAction?: {
    onClick(): void;
    label: string;
    color: TextButtonColor;
  };
  actions: LoadedActionsButtonItem[];
};

export function HoverCardWithCallToAction({
  cardTitle,
  contentsTitle,
  noContentsMessage,
  isLoading,
  errorMessage,
  children,
  actions
}: PropsWithChildren<HoverCardWithCallToActionButtonProps>) {
  const classes = useDeliveryContainerHoverCardStyles();

  return (
    <Card elevation={24} className={classes.root} onClick={(event) => event.preventDefault()}>
      {isLoading ? (
        <>
          <TextPlaceholder style={{ marginBottom: '20px' }} />
          <TextPlaceholder style={{ marginBottom: '20px' }} />
          <DeliveryCardPlaceholder />
        </>
      ) : (
        <>
          <section className={classes.header}>
            <h1 className={classes.title}>{cardTitle}</h1>
            {/* {callToAction ? (
              <TextButton
                onClick={callToAction.onClick}
                fontSize="12px"
                size="small"
                color={callToAction.color}
                variant="outlined"
              >
                {callToAction.label}
              </TextButton>
            ) : null} */}
            <ActionsButton itemArray={actions} variant="light" />
          </section>
          {errorMessage ? (
            <p className={classes.noContentsMessage}>{errorMessage}</p>
          ) : noContentsMessage ? (
            <p className={classes.noContentsMessage}>{noContentsMessage}</p>
          ) : (
            <>
              <section>
                <h1 className={classes.contentsTitle}>{contentsTitle}</h1>
              </section>
              <section>{children}</section>
            </>
          )}
        </>
      )}
    </Card>
  );
}
